import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole = 'all' }) => {
  // Get user from localStorage
  const isAuthenticated = localStorage.getItem('erp_auth_token');
  const userRole = localStorage.getItem('erp_user_role') || 'staff';

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If specific roles are required and user doesn't have access
  if (requiredRole !== 'all') {
    if (requiredRole === 'admin' && userRole !== 'admin') {
      return <Navigate to="/dashboard" replace />;
    }
    if (requiredRole === 'staff' && userRole !== 'admin' && userRole !== 'staff') {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // User is authenticated and authorized
  return children;
};

export default ProtectedRoute;